import { useState } from "react";
import { getImpersonation, stopImpersonation } from "../api/impersonation";

export function ImpersonationBanner() {
  const session = getImpersonation();
  const [pending, setPending] = useState(false);
  const [error, setError] = useState(false);
  if (!session) return null;
  const stop = async () => {
    setPending(true);
    setError(false);
    try {
      await stopImpersonation();
    } catch {
      setError(true);
      setPending(false);
    }
  };
  return (
    <aside
      aria-label={`Staff impersonation active for ${session.email}`}
      className="fixed top-2 left-7 z-[10000] flex min-w-24 flex-col items-stretch gap-0.5 rounded-md border border-amber-400 bg-amber-100 p-1 text-center text-[10px] font-semibold leading-3 text-neutral-900 shadow-md"
    >
      <span>Impersonating</span>
      {error ? (
        <span className="sr-only" role="alert">
          Could not stop impersonation. Try again.
        </span>
      ) : null}
      <button
        type="button"
        disabled={pending}
        onClick={() => void stop()}
        aria-label={`Stop impersonating ${session.email}`}
        className="rounded bg-neutral-900 px-2 py-0.5 text-[10px] font-semibold leading-3 text-white transition-colors hover:bg-neutral-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-900 focus-visible:ring-offset-1 focus-visible:ring-offset-amber-100 disabled:opacity-50"
      >
        {pending ? "Stopping…" : error ? "Retry stop" : "Stop"}
      </button>
    </aside>
  );
}
